// src/app/shared/user-data.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private buildingId: string | null = null;

  setBuildingId(buildingId: string): void {
    this.buildingId = buildingId;
  }

  getBuildingId(): string | null {
    return this.buildingId;
  }
}
